/* Bookish Queen wishlist (saved in the browser, no app)
   Loaded with defer from snippets/wishlist-header.liquid */
(function () {
  var KEY = 'bq_wishlist';
  var MAX = 60;

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(v) ? v : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) {
      list.unshift(handle);
      if (list.length > MAX) list.length = MAX;
    } else {
      list.splice(i, 1);
    }
    write(list);
    return i === -1;
  }

  function paint() {
    var list = read();
    var buttons = document.querySelectorAll('[data-wishlist-toggle]');
    for (var b = 0; b < buttons.length; b++) {
      var on = list.indexOf(buttons[b].getAttribute('data-wishlist-toggle')) !== -1;
      buttons[b].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    var counts = document.querySelectorAll('[data-wishlist-count]');
    for (var c = 0; c < counts.length; c++) {
      counts[c].textContent = list.length ? String(list.length) : '';
      counts[c].hidden = !list.length;
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    toggle(btn.getAttribute('data-wishlist-toggle'));
    paint();
    document.dispatchEvent(new CustomEvent('wishlist:change'));
  });

  // Keeps other open tabs in sync
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) {
      paint();
      document.dispatchEvent(new CustomEvent('wishlist:change'));
    }
  });

  window.BQWishlist = { read: read, write: write, toggle: toggle, paint: paint };

  paint();

  // Repaint hearts on product cards loaded later (filters, sorting, load more)
  var queued = false;
  new MutationObserver(function (records) {
    if (queued) return;
    for (var r = 0; r < records.length; r++) {
      var added = records[r].addedNodes;
      for (var n = 0; n < added.length; n++) {
        var node = added[n];
        if (node.nodeType === 1 && (node.matches('[data-wishlist-toggle]') || node.querySelector('[data-wishlist-toggle]'))) {
          queued = true;
          requestAnimationFrame(function () { queued = false; paint(); });
          return;
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
